// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/mobile/index';
import '/vendor/js/slick.js';

jQuery(function () {
  $('.s6-testi-in').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 8000,
    adaptiveHeight: true,
    fade: false,
    focusOnSelect: false,
  });

  offer.getState(function (data) {
    const cmp = data.query.cmp;
    if (cmp === 'false') {
      $('.n-block-smi').hide();
    }
  });
});
